import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { PatientEncounterDetails } from "@/test-data/PatientEncounterDetails";

interface PatientEncounterDialogProps {
  open: boolean;
  onClose: () => void;
  patientEncounterId: string;
}

export function PatientEncounterDialog({ open, onClose, patientEncounterId }: PatientEncounterDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-7xl max-h-[90vh] flex flex-col">
        <DialogHeader className="flex-shrink-0">
          <DialogTitle>Patient Encounter Expected Codes</DialogTitle>
        </DialogHeader>
        <div className="flex-1 overflow-auto">
          <PatientEncounterDetails encounterId={patientEncounterId} />
        </div>
      </DialogContent>
    </Dialog>
  );
}
